import type { ApprovalType } from 'ui-product-approvals-common';
import { hasOrderedApprovalSteps } from 'ui-product-approvals-common';

export const useHasOrderedApprovalSteps = (approvalType: ApprovalType) =>
  hasOrderedApprovalSteps({ approvalType });
